const polyline = require('@mapbox/polyline');

export const convertEncodedPolyLineToGoogleMapLatLng = (
  encodedPolyLine: string
) => {
  const decodedPolyLineDataset = polyline.decode(encodedPolyLine);
  const convertedPolyLineDataset = decodedPolyLineDataset.map(
    (decodedPolyLine: any) => {
      return new google.maps.LatLng(decodedPolyLine[0], decodedPolyLine[1]);
    }
  );
  return convertedPolyLineDataset;
};

export const generateAnimatedDirectionPolyLine = (map: any, path: any) => {
  const animatedPolyLine = new google.maps.Polyline({
    map,
    path,
    strokeColor: '#FFF',
    strokeOpacity: 1.0,
    strokeWeight: 5,
    zIndex: 2,
    icons: [
      {
        icon: {
          path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
          strokeColor: '#000',
          strokeOpacity: 1,
          fillOpacity: 1,
          fillColor: '#000',
          scale: 1.5,
        },
        offset: '0',
        repeat: '20px',
      },
    ],
  });

  let offset = 0;
  const animatedPolyLineTimer = setInterval(() => {
    offset = (offset + 1) % 200;
    const icons = animatedPolyLine.get('icons');
    icons[0].offset = offset + 'px';
    animatedPolyLine.set('icons', icons);
  }, 50);

  Object.defineProperties(animatedPolyLine, {
    $timer: {
      value: animatedPolyLineTimer,
      writable: false,
    },
    $clearTimer: {
      value: function () {
        clearInterval(this.$timer);
      },
      writable: false,
    },
  });

  return animatedPolyLine;
};

export const generateStaticDirectionPolyLine = (map: any, path: any) => {
  const staticPolyLine = new google.maps.Polyline({
    path,
    strokeColor: '#f15d00',
    strokeOpacity: 1,
    strokeWeight: 3,
    map,
    zIndex: 1,
  });

  return staticPolyLine;
};

export function getClosestDistanceToPolyline(polylines: any, waypoint: any) {
  let closestDistance = Infinity;
  let closestPoint = null;
  let closestDistanceIndex = -1;

  for (let i = 0; i < polylines.length - 1; i++) {
    const A = polylines[i];
    const B = polylines[i + 1];

    if (A.navigationInstruction?.maneuver !== 'DEPART') {
      continue;
    }

    const closestPointOnSegment = getClosestPointOnSegment(
      A.startLocation.latLng,
      B.startLocation.latLng,
      waypoint.location
    );
    const distance = haversineDistance(
      closestPointOnSegment,
      waypoint.location
    );

    if (distance < closestDistance) {
      closestDistance = distance;
      closestPoint = closestPointOnSegment;
      closestDistanceIndex = i;
    }
  }

  return { closestDistance, closestPoint, closestDistanceIndex };
}

function haversineDistance(coord1: any, coord2: any) {
  const R = 6371e3;
  const toRadians = (deg: any) => (deg * Math.PI) / 180;

  const dLat = toRadians(coord2.latitude - coord1.latitude);
  const dLon = toRadians(coord2.longitude - coord1.longitude);

  const lat1 = toRadians(coord1.latitude);
  const lat2 = toRadians(coord2.latitude);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
}

function getClosestPointOnSegment(A: any, B: any, P: any) {
  const toRadians = (deg: any) => (deg * Math.PI) / 180;
  const toDegrees = (rad: any) => (rad * 180) / Math.PI;

  const lat1 = toRadians(A.latitude);
  const lon1 = toRadians(A.longitude);
  const lat2 = toRadians(B.latitude);
  const lon2 = toRadians(B.longitude);
  const lat3 = toRadians(P.latitude);
  const lon3 = toRadians(P.longitude);

  const ABx = lon2 - lon1;
  const ABy = lat2 - lat1;
  const APx = lon3 - lon1;
  const APy = lat3 - lat1;

  const AB_AB = ABx * ABx + ABy * ABy;
  const AP_AB = APx * ABx + APy * ABy;

  let t = AP_AB / AB_AB;
  t = Math.max(0, Math.min(1, t));

  const closestLat = lat1 + t * ABy;
  const closestLng = lon1 + t * ABx;

  return {
    latitude: toDegrees(closestLat),
    longitude: toDegrees(closestLng),
  };
}
